// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import {BootstrapVue,BootstrapVueIcons } from 'bootstrap-vue'
import App from './App'
import router from './router'
import JsonExcel from 'vue-json-excel'
import Vuex from 'vuex'

import ServerError from './views/pages/500'
Vue.component('ServerError', ServerError)

Vue.use(BootstrapVueIcons)

import SimpleVueValidation from 'simple-vue-validator';
Vue.use(SimpleVueValidation);
Vue.prototype.Validator = SimpleVueValidation.Validator;

window.axios = require('axios')

// Vue.prototype.baseURL = 'http://localhost:6000' // URL for File retriving Globaly initialized
// axios.defaults.baseURL = 'http://localhost:6000' //Production Server URL
Vue.prototype.baseURL = 'http://13.233.236.21' // URL for File retriving Globaly initialized
axios.defaults.baseURL = 'http://13.233.236.21' //Development Server URL
axios.defaults.timeout = 60000;


import VueElementLoading from 'vue-element-loading'
Vue.component('VueElementLoading', VueElementLoading)



// todo
// cssVars()
Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.component('downloadExcel', JsonExcel)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})
